.option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  white-space: normal;
  min-width: 0;

  .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: var(--spacingSm);
  }

  .restrictedTextWidth {
    width: 150px;
  }

  .pill {
    height: 22px;
    width: 40px;
    min-width: 40px;
    border-radius: var(--radiusMd);
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
